import { render } from "./bonificoConfigDetails.vue?vue&type=template&id=01ad0ce8&ts=true"
import script from "./bonificoConfigDetails.vue?vue&type=script&lang=ts"
export * from "./bonificoConfigDetails.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__